module.exports = __webpack_public_path__ + "static/media/add.0b15f6df.svg";